export const LINKS = {
  wpp: 'https://wa.me/5521968087595',
  fb: 'https://www.facebook.com/sonixaparelhosauditivos',
  instagram: 'https://www.instagram.com/sonixaparelhosauditivos/',
  yt: 'https://www.youtube.com/@sonixaparelhosauditivos',
  linkedin: 'https://www.linkedin.com/in/gruposonix/',
  googleForms: 'https://docs.google.com/forms/d/e/1FAIpQLSdqg8ya23JGWFqyen9u19i7fng9SibpSkTAPeUfOofi4-HI-w/viewform'
}